import { render, staticRenderFns } from "./tableSubscriptionRightsOfINETW2.vue?vue&type=template&id=25a02997&scoped=true"
import script from "./tableSubscriptionRightsOfINETW2.vue?vue&type=script&lang=js"
export * from "./tableSubscriptionRightsOfINETW2.vue?vue&type=script&lang=js"
import style0 from "./tableSubscriptionRightsOfINETW2.vue?vue&type=style&index=0&id=25a02997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a02997",
  null
  
)

export default component.exports